import NavBar from './components/NavBar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import GallerySection from './components/GallerySection';
import BookingSection from './components/BookingSection';
import TestimonialsSection from './components/TestimonialsSection';
import FooterSection from './components/FooterSection';
import ProcessSection from './components/ProcessSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#faf8f5]">
      <NavBar />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <GallerySection />
        <ProcessSection />
        <TestimonialsSection />
        <BookingSection />
      </main>
      <FooterSection />
    </div>
  );
}
